/**
 * AI Hub Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.3.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ManagementAiPriceResponse {
    id?: string;
    provider?: ManagementAiPriceResponse.ProviderEnum;
    model?: string;
    pricePerMillionInputTokens?: number;
    pricePerMillionOutputTokens?: number;
    pricePerMillionCachedInputTokens?: number;
    effectiveFrom?: Date;
    createdAt?: Date;
    updatedAt?: Date;
}
export namespace ManagementAiPriceResponse {
    export type ProviderEnum = 'OPENAI' | 'GEMINI' | 'OPEN_ROUTER';
    export const ProviderEnum = {
        OPENAI: 'OPENAI' as ProviderEnum,
        GEMINI: 'GEMINI' as ProviderEnum,
        OPENROUTER: 'OPEN_ROUTER' as ProviderEnum
    };
}
